var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCall = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5275 15C10.7974 14.9756 10.0508 14.7643 9.33337 14.4508C7.17296 13.5074 5.38793 12.0481 3.77536 10.3605C2.60565 9.13645 1.59059 7.79662 0.834214 6.27497C0.405413 5.41362 0.0698712 4.51993 0.00754279 3.54611C-0.0397893 2.80379 0.128919 2.14536 0.704871 1.62049C1.10227 1.25823 1.46874 0.861301 1.85115 0.482176C2.49505 -0.157041 3.39577 -0.162196 4.04014 0.475615C4.69998 1.12889 5.34341 1.79951 6.01309 2.44247C6.75353 3.15386 6.55858 4.4487 5.53321 4.81095C4.89118 5.03777 4.52096 5.59591 4.58001 6.18218C4.6175 6.55568 4.75622 6.90809 4.94179 7.2352C5.70239 8.5769 6.75353 9.61024 8.18474 10.2195C8.90035 10.5241 9.6197 10.3188 10.0073 9.73114C10.0794 9.62195 10.1319 9.49823 10.1821 9.37639C10.5504 8.47989 11.6475 8.17387 12.3622 8.82481C13.1513 9.54369 13.9026 10.3085 14.6294 11.0916C15.1407 11.6418 15.0624 12.5167 14.5108 13.0856C14.0708 13.5393 13.619 13.9817 13.1705 14.4278C12.7324 14.8641 12.1827 14.9948 11.5275 15Z",
    fill: "#4A5981"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/call.23d1bd41.svg";
export { ForwardRef as ReactComponent };